export class ResetPasswordModule {
    public username: string='';
    public baseUrl: string='';
}